<template>
 <div :class="windowClass">
        <v-row no-gutters class="pa-1">
             <v-col md="12">
                  <v-card class="elevation-1">
                    <v-card-title class="mb-10">
                         <v-icon left color="primary">mdi-file-document-box-multiple-outline</v-icon> CASHIER SUMMARY
                            <v-divider class="ml-2" inset vertical/>
                              <v-spacer />
                              <v-spacer />
                              <v-spacer />
                               
                              <v-menu
                                  ref="menu"
                                  v-model="datemenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                              >
                                  <template v-slot:activator="{ on }">
                                  <v-text-field
                                      label="select date"
                                       :value="selected_date"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      dense
                                      single-line
                                      class="mr-2 sm-width"
                                      hide-details
                                      v-on="on"
                                  ></v-text-field>
                                  </template>
                                  <v-date-picker v-model="selected_date" no-title scrollable @input="datemenu=false, view='', viewReports()" />
                              </v-menu>
                              <v-select
                                 v-model="view"
                                :items="['TLC', 'FISHCAR SALES','CUSTOMER CASH SALES', 'CUSTOMER CREDIT SALES', 'CASHIER']"
                                dense
                                 prepend-icon="mdi-file"
                                 label="View Report"
                                single-line
                                hide-details
                                @change="viewReports()"
                                class="mr-3"
                                style="max-width: 250px !important;"
                              />
                    </v-card-title>
                      <v-btn class="ma-2" v-if="showtlc" small @click="print_tlc = true"><v-icon left>mdi-printer</v-icon> Print</v-btn>
                        <va-tlc-reports v-if="showtlc" :showdata="view" :show="showtlc" :selected_date="selected_date" />
                         <v-btn class="ma-2" v-if="showcustomer" small @click="print_credit = true"><v-icon left>mdi-printer</v-icon> Print</v-btn>
                        <va-credit-sales v-if="showcustomer" :showdata="view" :show="showcustomer" :selected_date="selected_date" />
                        <v-btn class="ma-2" v-if="showcustomercash" small @click="print_cash = true"><v-icon left>mdi-printer</v-icon> Print</v-btn>
                        <va-cash-sales v-if="showcustomercash" :showdata="view" :show="showcustomercash" :selected_date="selected_date" />
                        <va-cashier-reports v-if="showcashier" :show="showcashier" :selected_date="selected_date" />
                  </v-card>
            </v-col>
        </v-row>
      <print-tlc :show="print_tlc" :showdata="view" :selected_date="selected_date" @DialogEvent="prEvent"/>
      <print-credit :show="print_credit" :showdata="view" :selected_date="selected_date" @DialogEvent="prEvent"/>
       <print-cash :show="print_cash" :showdata="view" :selected_date="selected_date" @DialogEvent="prEvent"/>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
      view:"",
      print_tlc: false,
      print_credit: false,
      print_cash: false,
      showtlc: false,
      showsales: false,
      showcustomer: false,
      showcustomercash: false,
      showcashier: false,
      datemenu: false,
      selected_date:'',
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      prEvent(data){
        console.log(data)
        this.print_tlc = false
        this.print_credit = false
        this.print_cash = false
      },
      viewReports(){
          this.showtlc= false
          this.showsales= false
          this.showcustomer = false
          this.showcustomercash = false
          this.showcashier = false
          if(this.view == "TLC" || this.view == "FISHCAR SALES"){
             this.showtlc = true
          }
          if(this.view == "CUSTOMER CREDIT SALES"){
            //alert(this.selected_date)
             this.showcustomer = true
          }
          if(this.view == "CUSTOMER CASH SALES"){
             this.showcustomercash = true
          }
           if(this.view == "CASHIER"){
             this.showcashier = true
          }
      }
    },
  }
</script>